import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';
import { SettingsService } from '../../../core/settings/settings.service';
import { ReportsService } from '../reports.service';
import { CalendarService } from '../../configuration/calendar/calendar.service';
import { AdjustService } from '../../inventory/adjust/adjust.service';
import { Unit } from '../../common/models/Unit.Model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rep-movement',
  templateUrl: './rep-movement.component.html',
  styleUrls: ['./rep-movement.component.scss']
})
export class RepMovementComponent implements OnInit {

  downloading: boolean = false;
  esValidoRango: boolean = false;
  today: string = new Date().toISOString().split('T')[0];

  minDate: string;
  maxDate: string;
  
  // Variables para selectedValue
  orgSelected: any;
  regSelected: any;
  moveSelected: any = "0";
  moveSelected2: any = "0";

  // Listas para [items]
  organizacionList: Unit[] = [];
  regionList: any[] = [];
  moveList: any[] = [];
  moveList2: any[] = [];

  constructor(
    private reportService: ReportsService,
    private settings: SettingsService,
    private calendarService: CalendarService,
    private router: Router,
    private globalFunctionService: GlobalFunctionsService,
    private adjustService: AdjustService
  ) { }

  async ngOnInit() {
    this.globalFunctionService.canOperate();
    
    // Validaciones de bloqueo
    const isInvInProgress = await this.calendarService.CalendarInventoryInProgress().toPromise();
    if (isInvInProgress && isInvInProgress.length === 1) {
      this.globalFunctionService.messageToast(`Inventario físico en curso.`, 'warning');
      this.router.navigate(['/home']);
      return;
    }

    const isAdjustActive = await this.adjustService.validateAdjustActive(this.settings.getUser().UnitId).toPromise();
    if (isAdjustActive && isAdjustActive.AdjustCode !== '') {
      this.globalFunctionService.messageToast(`Se encuentra en compulsa.`, 'warning');
      this.router.navigate(['/home']);
      return;
    }

    this.initData();
  }

  initData() {
    const now = new Date();
    this.minDate = this.globalFunctionService.getStringDate(now, true, 0);
    this.maxDate = this.globalFunctionService.getStringDate(now, false, 0);

    this.getOrganizacion();
    this.getInventorMovementType2();
  }

  getOrganizacion(): void {
    const user = this.settings.getUser();
    this.reportService.getOrganizacionesByUser(user.Org, user.Id).subscribe((res: Unit[]) => {
      this.organizacionList = res;
      if (this.organizacionList.length > 0) {
        this.orgSelected = this.organizacionList[0].UnitId;
        this.changeFilterMovType2();
      }
    });
  }

  changeFilterMovType2() {
    const user = this.settings.getUser();
    // Importante: Asegurar que orgSelected tenga valor antes de llamar
    if(!this.orgSelected) return;

    this.reportService.getUserRegions(user.Org, user.Id, this.orgSelected).subscribe((res: any[]) => {
      this.regionList = res;
      if (this.regionList.length > 0) {
        this.regSelected = this.regionList[0].UnitId;
        this.changeFilterMovType3();
      }
    });
  }

  changeFilterMovType3() {
    const user = this.settings.getUser();
    if(!this.regSelected) return;

    this.reportService.getUserNodesByRegion(user.Org, user.Id, this.regSelected).subscribe((res: any[]) => {
      // Agregamos la opción "Todos" manualmente si el servicio no la trae
      this.moveList = [{ UnitId: "0", UnitDes: "Todos" }, ...res];
      this.moveSelected = "0";
    });
  }

  getInventorMovementType2(): void {
    this.reportService.getMovType().subscribe((res: any[]) => {
      this.moveList2 = [{ MovementType: "0", Description: "Todos" }, ...res];
      this.moveSelected2 = "0";
    });
  }

  async download() {
    const dInicio = new Date(this.minDate).getTime();
    const dFin = new Date(this.maxDate).getTime();
    const laps = 5184000000; 

    if ((dFin - dInicio) > laps) {
      this.globalFunctionService.messageToast(`Intervalo máximo de 60 días.`, 'warning');
      return;
    }

    await this.globalFunctionService.messageBimbo('Por favor espere...', 'loading', 'Generando reporte...');
    this.downloading = true;

    this.reportService.getRepInvMovementsExcel(
      this.minDate,
      this.maxDate,
      this.regSelected,
      this.moveSelected,
      this.moveSelected2
    ).subscribe({
      next: (resp: any) => {
        Swal.close();
        if (resp) {
          const blob = new Blob([resp], { type: resp.type });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.download = `Reporte_Movimientos.xlsx`;
          anchor.href = url;
          anchor.click();
        }
        this.downloading = false;
      },
      error: () => {
        Swal.close();
        this.globalFunctionService.messageToast(`Error al generar reporte.`, 'error');
        this.downloading = false;
      }
    });
  }
}